import React, { useEffect, useState } from "react";
import { Button, Card, CardContent, Modal, Box, TextField } from "@mui/material";
import { motion, AnimatePresence } from "framer-motion";
import Swal from "sweetalert2";
import axios from "axios";
import "./Concern.css";
import profileImage from "./sati.jpg"; // ? local image

const Concern = () => {
  const messages = [
    "Thank you for using our system! How has your experience been so far? Any difficulties we should address promptly?",
    "We appreciate your trust in our platform. Are teachers and students finding it intuitive and easy to navigate?",
    "Your feedback is invaluable! Have you noticed any issues or glitches we should fix to improve your experience?",
    "We�re grateful for your support. How confident are your staff and students in using the system daily?",
    "Hope the system is making school management easier! Are there any features you wish worked better or faster?",
    "Thank you for choosing our solution! How satisfied are teachers with grading, attendance, and communication tools in the system?",
    "We value your opinion! Any difficulties accessing reports, schedules, or student information we should improve immediately?",
    "Glad to have you onboard! How are students finding the system? Any feedback on usability or accessibility issues?",
    "Your support means a lot! Are there parts of the system that feel confusing or cumbersome for staff?",
    "We appreciate your continued trust! How smoothly is the system running during busy periods like exams or registration?",
    "Thank you for using our management system! Are notifications, announcements, and messages functioning well for everyone?",
    "Your feedback helps us grow! Are teachers able to easily enter grades and attendance without errors or delays?",
    "Grateful for your partnership! Do students feel engaged and supported when using the platform for assignments and grades?",
    "Hope the system simplifies your workflow! Any concerns with reports, dashboards, or user access we should address?",
    "Thank you for your confidence in us! How do teachers and administrators feel about system reliability and performance?",
    "We value your insights! Are students able to check grades and assignments without confusion or difficulty using the system?",
    "Your satisfaction is important! Any suggestions for additional features or improvements that would enhance daily school operations?",
    "Thank you for using our platform! Are teachers, students, and staff comfortable navigating the system without extra training?",
    "We appreciate your trust! How has the system impacted your school�s efficiency? Any issues we can resolve quickly?",
    "Grateful for your support! Are there any glitches, bugs, or slowdowns affecting daily use that we should address?",
  ];

  const [show, setShow] = useState(false);
  const [paused, setPaused] = useState(false);
  const [message, setMessage] = useState("");
  const [openModal, setOpenModal] = useState(false);
  const [feedback, setFeedback] = useState("");
  const [sending, setSending] = useState(false);

  // ? Show popup automatically once dashboard loads
  useEffect(() => {
    const randomMsg = messages[Math.floor(Math.random() * messages.length)];
    setMessage(randomMsg);
    setShow(true);

    const timer = setTimeout(() => {
      if (!paused) setShow(false);
    }, 9000);

    return () => clearTimeout(timer);
  }, [paused]);

  const handlePause = () => setPaused(!paused);
  const handleRemove = () => setShow(false);
  const handleOpenModal = () => setOpenModal(true);
  const handleCloseModal = () => setOpenModal(false);

  const handleFeedbackSubmit = async () => {
    if (!feedback.trim()) return;
    setSending(true);

    try {
      // ? Local storage save
      localStorage.setItem("user_feedback", feedback);

      // ? Or send to backend
      // await axios.post("https://your-backend-api.com/api/feedback/", { message: feedback });

      setFeedback("");
      setOpenModal(false);

      Swal.fire({
        icon: "success",
        title: "Thank you!",
        text: "Your feedback has been submitted successfully.",
        confirmButtonColor: "#3f1b01ff",
      });
    } catch (error) {
      console.error(error);
      Swal.fire({
        icon: "error",
        title: "Oops!",
        text: "Failed to send feedback. Please try again.",
      });
    } finally {
      setSending(false);
    }
  };

  return (
    <>
      <AnimatePresence>
        {show && (
          <motion.div
            className="concern-toast"
            initial={{ opacity: 0, y: 40 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: 40 }}
            transition={{ duration: 0.4 }}
          >
            <Card className="concern-card">
              <CardContent className="concern-content">
                <div className="concern-header">
                  <img src={profileImage} alt="Chris B. Sati" className="concern-img" />
                  <p className="concern-name">Chris B. Sati</p>
                </div>

                <p className="concern-message">{message}</p>

                <div className="concern-buttons">
                  <Button
                    variant="contained"
                    onClick={paused ? handleRemove : handlePause}
                    className="concern-btn"
                  >
                    {paused ? "Remove" : "Pause"}
                  </Button>
                  <Button
                    variant="outlined"
                    color="secondary"
                    onClick={handleOpenModal}
                    className="concern-feedback-btn"
                  >
                    Write Feedback
                  </Button>
                </div>
              </CardContent>
            </Card>
          </motion.div>
        )}
      </AnimatePresence>

      {/* ? Feedback Modal */}
      <Modal
        open={openModal}
        onClose={handleCloseModal}
        aria-labelledby="feedback-modal-title"
        BackdropProps={{
          style: { backgroundColor: "rgba(0,0,0,0.3)" },
        }}
        sx={{ display: "flex", justifyContent: "center", alignItems: "center" }}
      >
        <Box className="feedback-modal-box">
          <h3 id="feedback-modal-title" className="modal-title">
            Write Your Feedback
          </h3>
          <TextField
            fullWidth
            multiline
            minRows={3}
            placeholder="Type your feedback here..."
            value={feedback}
            onChange={(e) => setFeedback(e.target.value)}
          />
          <div className="modal-actions">
            <Button variant="outlined" onClick={handleCloseModal}>
              Cancel
            </Button>
            <Button
              variant="contained"
              color="primary"
              disabled={sending}
              onClick={handleFeedbackSubmit}
            >
              {sending ? "Sending..." : "Submit"}
            </Button>
          </div>
        </Box>
      </Modal>
    </>
  );
};

export default Concern;
